
import { cn } from "@/lib/utils";

interface CertificateCornersProps {
  style: {
    border: string;
  };
}

export function CertificateCorners({ style }: CertificateCornersProps) {
  return (
    <>
      <div className={cn(
        "absolute top-2 left-2 sm:top-4 sm:left-4 w-4 h-4 sm:w-8 sm:h-8 md:w-12 md:h-12 border-t-2 border-l-2",
        style.border,
        "animate-fade-in transition-all duration-500"
      )} style={{ animationDelay: "100ms" }} />
      <div className={cn(
        "absolute top-2 right-2 sm:top-4 sm:right-4 w-4 h-4 sm:w-8 sm:h-8 md:w-12 md:h-12 border-t-2 border-r-2",
        style.border,
        "animate-fade-in transition-all duration-500"
      )} style={{ animationDelay: "200ms" }} />
      <div className={cn(
        "absolute bottom-2 left-2 sm:bottom-4 sm:left-4 w-4 h-4 sm:w-8 sm:h-8 md:w-12 md:h-12 border-b-2 border-l-2",
        style.border,
        "animate-fade-in transition-all duration-500"
      )} style={{ animationDelay: "300ms" }} />
      <div className={cn(
        "absolute bottom-2 right-2 sm:bottom-4 sm:right-4 w-4 h-4 sm:w-8 sm:h-8 md:w-12 md:h-12 border-b-2 border-r-2",
        style.border,
        "animate-fade-in transition-all duration-500"
      )} style={{ animationDelay: "400ms" }} />
    </>
  );
}
